import m from "mithril"
import { state } from "../state/store.js"

export default {
  view: function () {
    var subtitle = (state.settings && state.settings.heroSubtitle)
      || "Exploring the intersection of design, code, and interaction."

    return m("section.hero", { id: "portfolio" }, [
      m("h1.hero-title", "Portfolio"),
      m("div.hero-content", { style: "max-width: 800px; margin-top: 2rem;" }, [
        m("p.hero-subtitle", { style: "font-size: 1.25rem; margin-bottom: 1.5rem; color: var(--color-text);" }, 
          "I'm an interactive developer passionate about exploring new technologies and pushing creative boundaries."
        ),
        m("p.hero-description", { style: "font-size: 1.1rem; margin-bottom: 2rem; color: var(--color-text-secondary); line-height: 1.8;" },
          "I love experimenting with cutting-edge tools and techniques to create interesting applications that blend art, technology, and user experience."
        ),
        m("div.hero-list", { style: "border-left: 2px solid var(--color-accent); padding-left: 1.5rem;" }, [
          m("p", { style: "margin-bottom: 0.5rem; font-weight: 500;" }, "My work spans across:"),
          m("ul", { style: "list-style: none; padding: 0; margin-top: 1rem; display: grid; gap: 0.75rem;" }, [
            m("li", "— Interactive websites and web experiences"),
            m("li", "— Exhibition installations and interactive displays"),
            m("li", "— Interactive games and playful experiences")
          ])
        ])
      ])
    ])
  },
}
